module.exports = __webpack_public_path__ + "static/img/ind_ban_08.ea8f1f96.jpeg";